import React from 'react';
import { Field, ErrorMessage } from 'formik';
import TextError from './TextError';

function Input(props) {
    const { label, name, formik, ...rest } = props;
    const isError = formik.touched[name] && formik.errors[name];

    // Convert ISO date to YYYY-MM-DD format for date input fields
    const formattedValue =
        rest?.type && rest?.type === 'date' && formik.values[name]
            ? new Date(formik.values[name]).toISOString().split('T')[0]
            : formik.values[name];

    return (
        <div className="form-row">
            {label && <label htmlFor={name}>{label}</label>}
            <Field
                id={name}
                name={name}
                value={formattedValue} 
                className={`${isError ? 'border-red' : 'border-gray-700'}`}
                {...rest}
                
            />
            <ErrorMessage component={TextError} name={name} />
        </div>
    );
}

export default Input;
